export enum apiMethodTypes {
  get = 'GET',
  post = 'POST'
}